//
import type { IPolicyServicingAgent } from '@/shared/api/models.bff';

export interface IAgent {
  id: string;
  cellPhone: string;
  firstName: string;
  lastName: string;
  email: string;
  name: string;
  title: string;
  titleDescription: string;
  office: string;
  phone?: string;
  homeOffice: boolean;
  lifeLicensed: boolean; // 'N' or 'Y'
  displayPic: string;
  securitiesLicensed: boolean; // 'N' or 'Y'
  isRvp: boolean;
  licensedProducts: string[];
}

export const mapAgentResponse = ({
  agentId,
  cellPhone,
  firstName,
  lastName,
  email,
  title,
  titleDesc,
  office,
  rvpAndUp,
  homeOfficeAgent,
  lifeLicensed,
  displayPic,
  securitiesLicensed,
  licensedProducts,
}: IPolicyServicingAgent): IAgent => {
  const mappedAgent = {
    id: agentId,
    cellPhone,
    firstName,
    lastName,
    email,
    name: `${firstName} ${lastName}`,
    title,
    titleDescription: titleDesc,
    office,
    phone: '',
    displayPic,
    isRvp: rvpAndUp,
    homeOffice: homeOfficeAgent,
    lifeLicensed: lifeLicensed === 'Y',
    securitiesLicensed: securitiesLicensed === 'Y',
    licensedProducts,
  };
  return mappedAgent;
};
